import type { Dayjs } from 'dayjs';
import { useRecoilState } from 'recoil';

import { dateFilterSchedulesTableAtom } from '../../state';

export const useSchedulesTableSelectedDateFilter = () => {
  const [selectedDateFilter, _setSelectedDateFilter] = useRecoilState(
    dateFilterSchedulesTableAtom
  );

  const setSelectedDateFilter = (date: [Dayjs, Dayjs]): void => {
    _setSelectedDateFilter(date);
  };

  return {
    selectedDateFilter,
    setSelectedDateFilter,
  };
};
